﻿import { NodeType } from '../Enums';
import { JourneyLine } from '../Journeys.viewmodel';

import { JourneyNode, UngappedJourney } from '@journeys/Journeys.viewmodel';

const initRuntimeProps = <T extends JourneyNode | JourneyLine>(item: T, print: (item: T) => void) => {
    print(item);
};

export const versionManager = (journey: UngappedJourney) => {
    let version = journey.Version ?? 0,
        print = blueprints[(version + 1) as 1];

    if (version >= blueprints.LATEST_VERSION) {
        for (let key in journey.nodes) {
            let node = journey.nodes[key];

            if (node.data.type === NodeType.Text) continue;

            initRuntimeProps(node as JourneyNode, blueprints.runtime.nodes);
        }

        // for (let key in journey.lines)
        //    initRuntimeProps(journey.lines[key], blueprints.runtime.lines)

        return;
    }

    // Nodes
    for (let key in journey.nodes) {
        let node = journey.nodes[key];

        if (node.data.type !== NodeType.Text) initRuntimeProps(node as JourneyNode, blueprints.runtime.nodes);

        // Add
        if (print.nodes.add.length)
            for (let add of print.nodes.add) {
                let path: any = node;

                for (let prop of add.path) path = path[prop];

                for (let prop of add.props) {
                    if (path[prop.key] !== undefined) continue;

                    if (typeof prop.value === 'object' && prop.value !== null) {
                        if (prop.value._FROM_PROP_) {
                            let fromProp: JourneyNode | any = node;

                            for (let p of prop.value._FROM_PROP_) {
                                if (p === '_THIS_') {
                                    fromProp = path;
                                    continue;
                                }

                                fromProp = fromProp[p];
                            }

                            path[prop.key] = fromProp;
                        } else if (prop.value._FROM_VALUE_) {
                            let values = prop.value._FROM_VALUE_.value,
                                fromValue: JourneyNode | any = node;

                            for (let p of prop.value._FROM_VALUE_.prop) {
                                if (p === '_THIS_') {
                                    fromValue = path;
                                    continue;
                                }

                                fromValue = fromValue[p];
                            }

                            path[prop.key] = values[fromValue as keyof typeof values];
                        } else path[prop.key] = prop.value;
                    } else path[prop.key] = prop.value;
                }
            }

        // Delete
        if (print.nodes.delete.length)
            for (let del of print.nodes.delete) {
                let path: any = node;

                for (let prop of del.path) path = path[prop];

                for (let key of del.keys) delete path[key];
            }
    }

    // // Lines
    // for (let key in journey.lines) {
    //    let line = journey.lines[key]

    //    initRuntimeProps(line, blueprints.runtime.lines)
    // }

    journey.Version = ++version;

    blueprints.LATEST_VERSION > journey.Version && versionManager(journey);
};

const blueprints = {
    LATEST_VERSION: 1,
    runtime: {
        // add runtime properties
        nodes: (item: JourneyNode) => {
            let props = {
                show: () => {},
                nx: item.x,
                ny: item.y,
                cache: {},
            };

            if (typeof item.runtime === 'object' && item.runtime !== null) item.runtime = { ...props, ...item.runtime };
            else item.runtime = props;
        },
        lines: (item: JourneyLine) => {},
    },

    //** NOTE: utility properties (that start and end with `_`) that specify a path to a value or prop
    //**** are treated as absolute in relation to the current item, unless `_THIS_` is set at the first index.
    // might be better to do this the other way around
    1: {
        nodes: {
            update: [],
            add: [
                {
                    path: ['data'],
                    props: [
                        {
                            key: 'delay_d',
                            value: {
                                _FROM_PROP_: ['_THIS_', 'delay'],
                            },
                        },
                        {
                            key: 'name',
                            value: {
                                _FROM_VALUE_: {
                                    prop: ['_THIS_', 'type'],
                                    value: {
                                        [NodeType.Segment]: 'List',
                                        [NodeType.Task]: 'Task',
                                        [NodeType.Condition]: 'Condition',
                                    },
                                },
                            },
                        },
                        {
                            key: 'var', // NodeVariation
                            value: {
                                _FROM_VALUE_: {
                                    prop: ['i'],
                                    value: {
                                        17: 1, // list
                                        20: 1, // email
                                        19: 2, // event
                                        1: 3, // survey
                                        28: 1, // delay
                                        18: 2, // condition
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
            delete: [
                {
                    path: ['data'],
                    keys: ['delay', 'delay_m'],
                },
            ],
        },
    },
};
